import React, { useState } from 'react';
import { CardDeckWrapper, KickerWrapper } from './styles/CardDeck.styled';
import { CardDeckSlide } from './CardDeck.Slide';

const CardDeckStandard = ({ component, heading, headingSize, subheading, kicker, cards, backgroundColor }) => {
  const [activeSlide, setActiveSlide] = useState('first-slide')

  let kickerBackground
  if (component?.backgroundColor === "grey" || backgroundColor === "grey") {
    kickerBackground = 'white'
  } else {
    kickerBackground = '#F2F4F7'
  }

  if (component && !component?.slide2Heading) {
    return (
      <CardDeckWrapper backgroundColor={component?.backgroundColor} noTopPadding={component?.noTopPadding} noBottomPadding={component?.noBottomPadding}>
        <CardDeckSlide
          heading={component?.heading}
          headingSize={component?.headingSize}
          subheading={component?.subheading?.subheading}
          kicker={component?.kicker}
          cards={component?.post}
          cardType={component?.cardType}
        />
      </CardDeckWrapper>
    )
  } else if (component && component?.slide2Heading) {
    return (
      <CardDeckWrapper backgroundColor={component?.backgroundColor}>
        <KickerWrapper activeSlide={activeSlide} kickerBackground={kickerBackground}>
          {component?.kicker &&
            <p onClick={() => { activeSlide !== 'first-slide' && setActiveSlide('first-slide') }} className="first-slide kicker">{component?.kicker}</p>
          }
          {component?.slide2Kicker &&
            <p onClick={() => { activeSlide !== 'second-slide' && setActiveSlide('second-slide') }} className="second-slide kicker">{component?.slide2Kicker}</p>
          }
        </KickerWrapper>
        <CardDeckSlide
          className={'first-slide'}
          activeSlide={activeSlide}
          heading={component?.heading}
          headingSize={component?.headingSize}
          subheading={component?.subheading?.subheading}
          cards={component?.post}
          cardType={component?.cardType}
        />
        <CardDeckSlide
          className={'second-slide'}
          activeSlide={activeSlide}
          heading={component?.slide2Heading}
          headingSize={component?.headingSize}
          subheading={component?.slide2Subheading?.slide2Subheading}
          cards={component?.slide2Post}
          cardType={component?.cardType}
        />
      </CardDeckWrapper>
    )
  } else {
    return (
      <CardDeckWrapper backgroundColor={backgroundColor}>
        <CardDeckSlide kicker={kicker} heading={heading} subheading={subheading} headingSize={headingSize} cards={cards} />
      </CardDeckWrapper>
    )
  }
};

CardDeckStandard.displayName = 'CardDeck';

export default CardDeckStandard
